var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M12.7676,7.5 L8.4996,7.5 L8.4996,5.595 C8.4996,4.699 9.0936,4.49 9.5116,4.49 L12.4996,4.49 L12.4996,0.548 L8.1706,0.535 C4.2446,0.535 3.4996,3.474 3.4996,5.355 L3.4996,7.5 L0.4996,7.5 L0.4996,11.5 L3.4996,11.5 L3.4996,23.5 L8.4996,23.5 L8.4996,11.5 L12.3506,11.5 L12.7676,7.5 L12.7676,7.5 Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.4c20d775.svg";
export { ForwardRef as ReactComponent };